import { Box, CircularProgress, Grid } from '@material-ui/core';
import { Dialog } from 'src/components';
import { PDFViewer } from '@react-pdf/renderer';
import { useEffect } from 'react';
import CertificatePDF from './CertificatePdf';

import { type ICourse } from 'src/models';
import { type RootState } from 'src/store';
import { timeString } from 'src/helpers';
import { useDispatch, useSelector } from 'react-redux';
import courseActions from 'src/store/Courses/actions';
import moment from 'moment';

interface Props {
	open: boolean;
	handleOpen: () => void;
	course: ICourse;
}

function CertificateDialog({ course, handleOpen, open }: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) => state.auth.data);
	const { isLoadingCertificate, userCertificate } = useSelector(
		(state: RootState) => state.courses,
	);

	useEffect(() => {
		if (open) {
			dispatch(courseActions.getUserCertificate(user.id, course.id!));
		}
	}, [open]);

	return (
		<Dialog
			content={
				isLoadingCertificate ? (
					<Grid
						alignItems={'center'}
						container
						justify={'center'}
						style={{ height: 500, width: '100%' }}
					>
						<CircularProgress color={'primary'} />
					</Grid>
				) : (
					<Box
						display={'flex'}
						flexDirection={'column'}
						height={'100%'}
					>
						<Box flexGrow={1}>
							<PDFViewer
								height={'100%'}
								style={{ border: 'none' }}
								width={'100%'}
							>
								<CertificatePDF
									courseName={
										userCertificate.courseName || ''
									}
									date={moment(userCertificate.date).format(
										'MMMM DD, YYYY',
									)}
									department={
										userCertificate.department || ''
									}
									duration={timeString(
										userCertificate.duration,
									)}
									institutionName={
										userCertificate.institutionName || ''
									}
									name={userCertificate.user || ''}
									qualification={
										userCertificate.qualification
									}
									showInstitution={
										userCertificate.showInstitution
									}
									showPosition={userCertificate.showPosition}
								/>
							</PDFViewer>
						</Box>
					</Box>
				)
			}
			fullScreen
			handleOpen={handleOpen}
			maxWidth={'xl'}
			noPadding
			open={open}
			title={'Certificado'}
		/>
	);
}

export default CertificateDialog;
